import * as api from '../api/deed';
import { makeApiActionCreatorV3 } from '@actions/utils';
import { createRequestTypes, START, SUCCESS, ERROR } from './global';

const namespace = 'APPRAISAL/DEED';

export const DEEDS_FETCH_START = `${namespace}/DEEDS_FETCH_START`;
export const DEEDS_FETCH_SUCCESS = `${namespace}/DEEDS_FETCH_SUCCESS`;
export const DEEDS_FETCH_ERROR = `${namespace}/DEEDS_FETCH_ERROR`;

export const fetchPropertyDeeds = makeApiActionCreatorV3(
  api.fetchPropertyDeeds,
  DEEDS_FETCH_START,
  DEEDS_FETCH_SUCCESS,
  DEEDS_FETCH_ERROR,
);

export const DEED_FETCH_MOST_CURRENT = createRequestTypes(
  `${namespace}/DEED_FETCH_MOST_CURRENT`,
);

export const fetchMostCurrentDeed = makeApiActionCreatorV3(
  api.fetchMostCurrentDeed,
  DEED_FETCH_MOST_CURRENT[START],
  DEED_FETCH_MOST_CURRENT[SUCCESS],
  DEED_FETCH_MOST_CURRENT[ERROR],
);

export const DEED_DELETE_START = `${namespace}/DEED_DELETE_START`;
export const DEED_DELETE_SUCCESS = `${namespace}/DEED_DELETE_SUCCESS`;
export const DEED_DELETE_ERROR = `${namespace}/DEED_DELETE_ERROR`;

export const deletePropertyDeed = makeApiActionCreatorV3(
  api.deletePropertyDeed,
  DEED_DELETE_START,
  DEED_DELETE_SUCCESS,
  DEED_DELETE_ERROR,
);

export const DEEDS_REORDER_START = `${namespace}/DEEDS_REORDER_START`;
export const DEEDS_REORDER_SUCCESS = `${namespace}/DEEDS_REORDER_SUCCESS`;
export const DEEDS_REORDER_ERROR = `${namespace}/DEEDS_REORDER_ERROR`;

export const reorderPropertyDeeds = makeApiActionCreatorV3(
  api.reorderPropertyDeeds,
  DEEDS_REORDER_START,
  DEEDS_REORDER_SUCCESS,
  DEEDS_REORDER_ERROR,
);

export const DEED_FETCH_START = `${namespace}/DEED_FETCH_START`;
export const DEED_FETCH_SUCCESS = `${namespace}/DEED_FETCH_SUCCESS`;
export const DEED_FETCH_ERROR = `${namespace}/DEED_FETCH_ERROR`;

export const fetchDeed = makeApiActionCreatorV3(
  api.fetchDeed,
  DEED_FETCH_START,
  DEED_FETCH_SUCCESS,
  DEED_FETCH_ERROR,
);

export const DEED_TYPES_FETCH_START = `${namespace}/DEED_TYPES_FETCH_START`;
export const DEED_TYPES_FETCH_SUCCESS = `${namespace}/DEED_TYPES_FETCH_SUCCESS`;
export const DEED_TYPES_FETCH_ERROR = `${namespace}/DEED_TYPES_FETCH_ERROR`;

export const fetchDeedTypes = makeApiActionCreatorV3(
  api.fetchDeedTypes,
  DEED_TYPES_FETCH_START,
  DEED_TYPES_FETCH_SUCCESS,
  DEED_TYPES_FETCH_ERROR,
);

export const DEED_CREATE_START = `${namespace}/DEED_CREATE_START`;
export const DEED_CREATE_SUCCESS = `${namespace}/DEED_CREATE_SUCCESS`;
export const DEED_CREATE_ERROR = `${namespace}/DEED_CREATE_ERROR`;

export const createPropertyDeed = makeApiActionCreatorV3(
  api.createPropertyDeed,
  DEED_CREATE_START,
  DEED_CREATE_SUCCESS,
  DEED_CREATE_ERROR,
);

export const DEED_UPDATE_START = `${namespace}/DEED_UPDATE_START`;
export const DEED_UPDATE_SUCCESS = `${namespace}/DEED_UPDATE_SUCCESS`;
export const DEED_UPDATE_ERROR = `${namespace}/DEED_UPDATE_ERROR`;

export const updatePropertyDeed = makeApiActionCreatorV3(
  api.updatePropertyDeed,
  DEED_UPDATE_START,
  DEED_UPDATE_SUCCESS,
  DEED_UPDATE_ERROR,
);

export const DEED_PROPERTIES_FETCH_START = `${namespace}/DEED_PROPERTIES_FETCH_START`;
export const DEED_PROPERTIES_FETCH_SUCCESS = `${namespace}/DEED_PROPERTIES_FETCH_SUCCESS`;
export const DEED_PROPERTIES_FETCH_ERROR = `${namespace}/DEED_PROPERTIES_FETCH_ERROR`;

export const fetchDeedProperties = makeApiActionCreatorV3(
  api.fetchDeedProperties,
  DEED_PROPERTIES_FETCH_START,
  DEED_PROPERTIES_FETCH_SUCCESS,
  DEED_PROPERTIES_FETCH_ERROR,
);

export const DEED_PROPERTY_CREATE_START = `${namespace}/DEED_PROPERTY_CREATE_START`;
export const DEED_PROPERTY_CREATE_SUCCESS = `${namespace}/DEED_PROPERTY_CREATE_SUCCESS`;
export const DEED_PROPERTY_CREATE_ERROR = `${namespace}/DEED_PROPERTY_CREATE_ERROR`;

export const createDeedProperty = makeApiActionCreatorV3(
  api.createDeedProperty,
  DEED_PROPERTY_CREATE_START,
  DEED_PROPERTY_CREATE_SUCCESS,
  DEED_PROPERTY_CREATE_ERROR,
);

export const DEED_PROPERTY_FETCH_START = `${namespace}/DEED_PROPERTY_FETCH_START`;
export const DEED_PROPERTY_FETCH_SUCCESS = `${namespace}/DEED_PROPERTY_FETCH_SUCCESS`;
export const DEED_PROPERTY_FETCH_ERROR = `${namespace}/DEED_PROPERTY_FETCH_ERROR`;

export const fetchDeedProperty = makeApiActionCreatorV3(
  api.fetchDeedProperty,
  DEED_PROPERTY_FETCH_START,
  DEED_PROPERTY_FETCH_SUCCESS,
  DEED_PROPERTY_FETCH_ERROR,
);

export const DEED_PROPERTY_DELETE_START = `${namespace}/DEED_PROPERTY_DELETE_START`;
export const DEED_PROPERTY_DELETE_SUCCESS = `${namespace}/DEED_PROPERTY_DELETE_SUCCESS`;
export const DEED_PROPERTY_DELETE_ERROR = `${namespace}/DEED_PROPERTY_DELETE_ERROR`;

export const deleteDeedProperty = makeApiActionCreatorV3(
  api.deleteDeedProperty,
  DEED_PROPERTY_DELETE_START,
  DEED_PROPERTY_DELETE_SUCCESS,
  DEED_PROPERTY_DELETE_ERROR,
);

export const FILES_FETCH_START = `${namespace}/FILES_FETCH_START`;
export const FILES_FETCH_SUCCESS = `${namespace}/FILES_FETCH_SUCCESS`;
export const FILES_FETCH_ERROR = `${namespace}/FILES_FETCH_ERROR`;

export const fetchFiles = makeApiActionCreatorV3(
  api.fetchFiles,
  FILES_FETCH_START,
  FILES_FETCH_SUCCESS,
  FILES_FETCH_ERROR,
);

export const FILE_CREATE_START = `${namespace}/FILE_CREATE_START`;
export const FILE_CREATE_SUCCESS = `${namespace}/FILE_CREATE_SUCCESS`;
export const FILE_CREATE_ERROR = `${namespace}/FILE_CREATE_ERROR`;

export const createFile = makeApiActionCreatorV3(
  api.createFile,
  FILE_CREATE_START,
  FILE_CREATE_SUCCESS,
  FILE_CREATE_ERROR,
);

export const FILE_UPDATE_START = `${namespace}/FILE_UPDATE_START`;
export const FILE_UPDATE_SUCCESS = `${namespace}/FILE_UPDATE_SUCCESS`;
export const FILE_UPDATE_ERROR = `${namespace}/FILE_UPDATE_ERROR`;

export const updateFile = makeApiActionCreatorV3(
  api.updateFile,
  FILE_UPDATE_START,
  FILE_UPDATE_SUCCESS,
  FILE_UPDATE_ERROR,
);

export const FILE_DELETE_START = `${namespace}/FILE_DELETE_START`;
export const FILE_DELETE_SUCCESS = `${namespace}/FILE_DELETE_SUCCESS`;
export const FILE_DELETE_ERROR = `${namespace}/FILE_DELETE_ERROR`;

export const deleteFile = makeApiActionCreatorV3(
  api.deleteFile,
  FILE_DELETE_START,
  FILE_DELETE_SUCCESS,
  FILE_DELETE_ERROR,
);

export const FILE_GET_START = `${namespace}/FILE_GET_START`;
export const FILE_GET_SUCCESS = `${namespace}/FILE_GET_SUCCESS`;
export const FILE_GET_ERROR = `${namespace}/FILE_GET_ERROR`;

export const getFile = makeApiActionCreatorV3(
  api.getFile,
  FILE_GET_START,
  FILE_GET_SUCCESS,
  FILE_GET_ERROR,
);

export const DEED_SELLER_CREATE_START = `${namespace}/DEED_SELLER_CREATE_START`;
export const DEED_SELLER_CREATE_SUCCESS = `${namespace}/DEED_SELLER_CREATE_SUCCESS`;
export const DEED_SELLER_CREATE_ERROR = `${namespace}/DEED_SELLER_CREATE_ERROR`;

export const createDeedSeller = makeApiActionCreatorV3(
  api.createDeedSeller,
  DEED_SELLER_CREATE_START,
  DEED_SELLER_CREATE_SUCCESS,
  DEED_SELLER_CREATE_ERROR,
);

export const DEED_SELLER_DELETE_START = `${namespace}/DEED_SELLER_DELETE_START`;
export const DEED_SELLER_DELETE_SUCCESS = `${namespace}/DEED_SELLER_DELETE_SUCCESS`;
export const DEED_SELLER_DELETE_ERROR = `${namespace}/DEED_SELLER_DELETE_ERROR`;

export const deleteDeedSeller = makeApiActionCreatorV3(
  api.deleteDeedSeller,
  DEED_SELLER_DELETE_START,
  DEED_SELLER_DELETE_SUCCESS,
  DEED_SELLER_DELETE_ERROR,
);

export const DEED_SELLER_UPDATE_START = `${namespace}/DEED_SELLER_UPDATE_START`;
export const DEED_SELLER_UPDATE_SUCCESS = `${namespace}/DEED_SELLER_UPDATE_SUCCESS`;
export const DEED_SELLER_UPDATE_ERROR = `${namespace}/DEED_SELLER_UPDATE_ERROR`;

export const updateDeedSeller = makeApiActionCreatorV3(
  api.updateDeedSeller,
  DEED_SELLER_UPDATE_START,
  DEED_SELLER_UPDATE_SUCCESS,
  DEED_SELLER_UPDATE_ERROR,
);

export const DEED_SELLERS_FETCH_START = `${namespace}/DEED_SELLERS_FETCH_START`;
export const DEED_SELLERS_FETCH_SUCCESS = `${namespace}/DEED_SELLERS_FETCH_SUCCESS`;
export const DEED_SELLERS_FETCH_ERROR = `${namespace}/DEED_SELLERS_FETCH_ERROR`;

export const fetchDeedSellers = makeApiActionCreatorV3(
  api.fetchDeedSellers,
  DEED_SELLERS_FETCH_START,
  DEED_SELLERS_FETCH_SUCCESS,
  DEED_SELLERS_FETCH_ERROR,
);

export const DEED_BUYER_CREATE_START = `${namespace}/DEED_BUYER_CREATE_START`;
export const DEED_BUYER_CREATE_SUCCESS = `${namespace}/DEED_BUYER_CREATE_SUCCESS`;
export const DEED_BUYER_CREATE_ERROR = `${namespace}/DEED_BUYER_CREATE_ERROR`;

export const createDeedBuyer = makeApiActionCreatorV3(
  api.createDeedBuyer,
  DEED_BUYER_CREATE_START,
  DEED_BUYER_CREATE_SUCCESS,
  DEED_BUYER_CREATE_ERROR,
);

export const DEED_BUYER_DELETE_START = `${namespace}/DEED_BUYER_DELETE_START`;
export const DEED_BUYER_DELETE_SUCCESS = `${namespace}/DEED_BUYER_DELETE_SUCCESS`;
export const DEED_BUYER_DELETE_ERROR = `${namespace}/DEED_BUYER_DELETE_ERROR`;

export const deleteDeedBuyer = makeApiActionCreatorV3(
  api.deleteDeedBuyer,
  DEED_BUYER_DELETE_START,
  DEED_BUYER_DELETE_SUCCESS,
  DEED_BUYER_DELETE_ERROR,
);

export const DEED_BUYER_UPDATE_START = `${namespace}/DEED_BUYER_UPDATE_START`;
export const DEED_BUYER_UPDATE_SUCCESS = `${namespace}/DEED_BUYER_UPDATE_SUCCESS`;
export const DEED_BUYER_UPDATE_ERROR = `${namespace}/DEED_BUYER_UPDATE_ERROR`;

export const updateDeedBuyer = makeApiActionCreatorV3(
  api.updateDeedBuyer,
  DEED_BUYER_UPDATE_START,
  DEED_BUYER_UPDATE_SUCCESS,
  DEED_BUYER_UPDATE_ERROR,
);

export const DEED_BUYERS_FETCH_START = `${namespace}/DEED_BUYERS_FETCH_START`;
export const DEED_BUYERS_FETCH_SUCCESS = `${namespace}/DEED_BUYERS_FETCH_SUCCESS`;
export const DEED_BUYERS_FETCH_ERROR = `${namespace}/DEED_BUYERS_FETCH_ERROR`;

export const fetchDeedBuyers = makeApiActionCreatorV3(
  api.fetchDeedBuyers,
  DEED_BUYERS_FETCH_START,
  DEED_BUYERS_FETCH_SUCCESS,
  DEED_BUYERS_FETCH_ERROR,
);

export const RESET_DEED = `${namespace}/RESET_DEED`;

export const resetDeed = () => ({
  type: RESET_DEED,
});

export const SET_CURRENT_DEED = `${namespace}/SET_CURRENT_DEED`;

export const setCurrentDeed = payload => ({
  type: SET_CURRENT_DEED,
  payload,
});

// deed lookup modal
export const OPEN_DEED_LOOKUP_MODAL = `${namespace}/OPEN_DEED_LOOKUP_MODAL`;
export const CLOSE_DEED_LOOKUP_MODAL = `${namespace}/CLOSE_DEED_LOOKUP_MODAL`;
export const LOOKUP_DEED = createRequestTypes(`${namespace}/LOOKUP_DEED`);
export const MODAL_SELECT_DEED_RECORDS = `${namespace}/MODAL_SELECT_DEED_RECORDS`;

export const openDeedLookupModal = mode => ({
  type: OPEN_DEED_LOOKUP_MODAL,
  payload: mode,
});

export const lookupDeed = makeApiActionCreatorV3(
  api.fetchPropertyDeeds,
  LOOKUP_DEED[START],
  LOOKUP_DEED[SUCCESS],
  LOOKUP_DEED[ERROR],
);

export const closeDeedLookupModal = () => ({
  type: CLOSE_DEED_LOOKUP_MODAL,
});

export const deedLookupModalSelectRecords = deeds => ({
  type: MODAL_SELECT_DEED_RECORDS,
  payload: deeds,
});

export const DEED_FETCH_DEEDS_START = `${namespace}/DEED_FETCH_DEEDS_START`;
export const DEED_FETCH_DEEDS_SUCCESS = `${namespace}/DEED_FETCH_DEEDS_SUCCESS`;
export const DEED_FETCH_DEEDS_ERROR = `${namespace}/DEED_FETCH_DEEDS_ERROR`;

export const fetchDeeds = makeApiActionCreatorV3(
  api.fetchDeeds,
  DEED_FETCH_DEEDS_START,
  DEED_FETCH_DEEDS_SUCCESS,
  DEED_FETCH_DEEDS_ERROR,
);

export const DEED_FETCH_LETTER_CODES = createRequestTypes(
  `${namespace}/DEED_FETCH_LETTER_CODES`,
);
export const fetchLetterCodes = makeApiActionCreatorV3(
  api.fetchLetterCodes,
  DEED_FETCH_LETTER_CODES[START],
  DEED_FETCH_LETTER_CODES[SUCCESS],
  DEED_FETCH_LETTER_CODES[ERROR],
);

export const DEED_ADD_LETTER_CODE = createRequestTypes(
  `${namespace}/DEED_ADD_LETTER_CODE`,
);
export const addLetterCode = makeApiActionCreatorV3(
  api.addLetterCode,
  DEED_ADD_LETTER_CODE[START],
  DEED_ADD_LETTER_CODE[SUCCESS],
  DEED_ADD_LETTER_CODE[ERROR],
);

export const DEED_DELETE_LETTER_CODE = createRequestTypes(
  `${namespace}/DEED_DELETE_LETTER_CODE`,
);
export const deleteLetterCode = makeApiActionCreatorV3(
  api.deleteLetterCode,
  DEED_DELETE_LETTER_CODE[START],
  DEED_DELETE_LETTER_CODE[SUCCESS],
  DEED_DELETE_LETTER_CODE[ERROR],
);
